import { API } from "@/lib/api";
import { Overline, Card } from "./shared";

const SITE_ROOT = API.replace("/api", "");

export const BrandResult = ({ r }) => (
  <div data-testid="bb-result-brand" className="grid grid-cols-1 lg:grid-cols-3 gap-5">
    <Card className="lg:row-span-2 flex flex-col items-center justify-center bg-[#fafafa]">
      <Overline>AI logo</Overline>
      {r.logo_url ? (
        <>
          <img
            src={`${SITE_ROOT}${r.logo_url}`}
            alt="Generated logo"
            data-testid="bb-logo-img"
            className="w-44 h-44 object-contain border border-black bg-white"
          />
          <a
            href={`${SITE_ROOT}${r.logo_url}`}
            download
            className="mt-4 border border-black px-4 py-2 overline hover:bg-black hover:text-white"
          >
            Download ↓
          </a>
        </>
      ) : (
        <div className="font-mono text-xs text-[#52525b]">Logo unavailable — regenerate</div>
      )}
    </Card>
    <Card>
      <Overline>Slogan</Overline>
      <div className="font-display font-extrabold text-2xl tracking-tight">&ldquo;{r.slogan}&rdquo;</div>
      <div className="mt-3 flex flex-wrap gap-2">
        {(r.brand_personality || []).map((p) => (
          <span key={p} className="font-mono text-xs border border-black px-2 py-1">{p}</span>
        ))}
      </div>
    </Card>
    <Card>
      <Overline>Colors &amp; type</Overline>
      <div className="flex gap-2">
        {(r.colors || []).map((c) => (
          <div key={c.hex} className="flex-1">
            <div className="h-12 border border-black" style={{ background: c.hex }} />
            <div className="font-mono text-[10px] mt-1">{c.hex}<br />{c.role}</div>
          </div>
        ))}
      </div>
      <div className="font-mono text-xs mt-3">
        {r.typography?.heading} / {r.typography?.body}
      </div>
    </Card>
    <Card>
      <Overline>Mission</Overline>
      <p className="text-sm">{r.mission}</p>
    </Card>
    <Card>
      <Overline>Vision</Overline>
      <p className="text-sm">{r.vision}</p>
    </Card>
  </div>
);
